import { Routes } from '@angular/router';
import { AuthGuard, RouteGuard } from '@core/shared';
import { OfflineOrderHistoryComponent } from './offlineorderhistory/offlineorderhistory.component';

export const OfflineOrderManagementRoutes: Routes = [
    {
        path: 'offlineorderhistory',
        canActivate: [AuthGuard, RouteGuard],
        component: OfflineOrderHistoryComponent,
        pathMatch: 'full',
        data: { title: 'Offline Order tracking', isPreLogin: false }
    }
];